import React from 'react';

import { useDynamicIcon } from '@lumapps/assets/hooks/useDynamicIcon';
import { Icon, IconProps } from '@lumapps/lumx/react';

export interface DynamicIconProps extends Omit<IconProps, 'icon'> {
    /** The mdi icon class to fetch. */
    icon: string;
}

/**
 * Icon that will dynamically fetch the mdi icon from given icon class.
 *
 * @family Buttons
 * @param DynamicIconButtonProps
 * @returns DynamicIconButton
 */
export const DynamicIcon = React.forwardRef<HTMLElement, DynamicIconProps>(({ icon, ...forwardedProps }, ref) => {
    const { iconPath } = useDynamicIcon({ icon });

    return <Icon ref={ref} icon={iconPath} {...forwardedProps} />;
});
